import React from "react";
import {  FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp, FaYoutube } from "react-icons/fa";

const SocialLinks = () => {
  return (
    <div className="d-flex">
      <div className="social-icon-wrapper">
        <ul className="social-icons">
          <li className="prt-social-facebook">
            <a
              target="_blank"
              href="https://www.facebook.com/magj1972"
              rel="noopener noreferrer"
              data-tooltip="Facebook"
              aria-label="Facebook"
            >
              <FaFacebookF size={"18px"} />
            </a>
          </li>
          <li className="prt-social-instagram">
            <a
              target="_blank"
              href="https://www.instagram.com/equipomag"
              rel="noopener noreferrer"
              data-tooltip="Instagram"
              aria-label="Instagram"
            >
              <FaInstagram size={"18px"} />
            </a>
          </li>
          <li className="prt-social-tiktok">
            <a
              target="_blank"
              href="https://www.tiktok.com/@equipomag"
              rel="noopener noreferrer"
              data-tooltip="TikTok"
              aria-label="TikTok"
            >
              <FaTiktok size={"18px"} />
            </a>
          </li>
          {/* <li className="prt-social-email">
            <a
              target="_blank"
              href="mailto:central@equipomag.com"
              rel="noopener noreferrer"
              data-tooltip="Email"
              aria-label="Email"
            >
              <FaEnvelope size={"18px"} />
            </a>
          </li> */}
          {/* <li className="prt-social">
            <a
              target="_blank"
              href="https://www.linkedin.com/company/equipomag/"
              rel="noopener noreferrer"
              data-tooltip="LinkedIn"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn size={"18px"} />

            </a>
          </li> */}
          <li className="prt-social-youtube">
            <a
              target="_blank"
              href="https://www.youtube.com/channel/UCp0-S7GBhsDoYHqr3DaMD0w"
              rel="noopener noreferrer"
              data-tooltip="YouTube"
              aria-label="YouTube"
            >
              <FaYoutube size={"18px"} />
            </a>
          </li>
          <li className="prt-social-whatsapp">
            <a
              target="_blank"
              href="https://wa.me/+34621234462"
              rel="noopener noreferrer"
              data-tooltip="WhatsApp"
              aria-label="WhatsApp"
            >
              <FaWhatsapp size={"18px"} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SocialLinks;
